import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Form, Button, Modal, Alert, CloseButton } from "react-bootstrap";
import { ToastContainer, toast, Slide } from 'react-toastify';
import { FaUserClock, FaCheckCircle, FaRegTimesCircle, FaClipboardCheck, FaSpinner, FaFileAlt, FaTruck, FaBoxOpen, FaPrint } from 'react-icons/fa';
import { GiPathDistance } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import axios from 'axios';
import '../styles/MenuTrack.css'
import '../styles/TrackRequests.css';
import 'react-toastify/dist/ReactToastify.css';

export default function SingleTrack() {
    const notify = (type, message) => {
        const properties = {
          position: "bottom-right",
          transition: Slide,
          autoClose: 1900,
          draggable: true,
          closeOnClick: true,
          pauseOnHover: false,
        }

        if (toast[type]) {
            toast[type](message, properties); // e.g., toast.success("Success message")
        } else {
            toast(message, properties); // Default toast if type is unknown
        }

        // TODO custom css class
    } 

    // const [_, setRefresh] = useState(0);

    // const refreshPage = () => {
    //     setRefresh(n => n + 1);
    // };

    var { refNumber } = useParams();
    const location = useLocation();

    const { trackingName } = location.state || {};

    // console.warn("reference: ", refNumber);
    // console.warn("lastname: ", trackingName);

    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const receiptImageRef = useRef(null);
    const fileInputRef = useRef(null);  
    const [preview, setPreview] = useState(null); // For storing the image preview

    const MAX_FILE_SIZE_MB = 20; // 20MB Limit
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert to Bytes

    const [courses, setCourses] = useState([]);

    const fetchCourses = async () => {
        try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/courses.php');
            
            // Handle different response formats
            let coursesData = [];
            if (Array.isArray(response.data)) {
                coursesData = response.data;
            } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
                coursesData = response.data.data;
            } else if (response.data && response.data.courses) {
                coursesData = response.data.courses;
            }
            
            if (coursesData.length > 0) {
                setCourses(coursesData);
            } else {
                console.warn("No courses found in response");
            }
        } catch (error) {
            console.error("Error fetching courses:", error);
            notify("error", "Failed to load course list");
        }
    };

    const [claimData, setClaimData] = useState({
        receiver_name: '',
        receive_date: '',
        claimed_by: ''
    });
    const [isClaimLoading, setIsClaimLoading] = useState(false);

    useEffect(() => {
        if (!refNumber || !trackingName) return;
  
        const fetchClaimData = async () => {
        setIsClaimLoading(true);
        try {
            const response = await axios.get(
            `https://docuquest-swu.swucite.tech/api_drts/transactionsClaim.php`, 
            {
                params: {
                ref: refNumber,
                lastname: trackingName
                }
            }
            );
    
            if (response.data.status === 1 && response.data.data) {
            setClaimData(response.data.data);
            }
        } catch (error) {
            //console.error("Error fetching claim data:", error);
            notify("error", "Error loading claim information");
        } finally {
            setIsClaimLoading(false);
        }
        };
  
    fetchClaimData();
    }, [refNumber, trackingName]);

    const handleFileChange = (e) => {
      const file = e.target.files[0];
      // "image/jpeg", 
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!file) {
        setPreview(null);
        notify("warning", `No file selected`);
        // setError("No file selected.");
        return;
      }

      if (file && !allowedTypes.includes(file.type)) {
        notify("error", `Invalid file type. Please upload a JPEG, PNG, or PDF image.`);
        //setError("Invalid file type. Please upload a PNG image.");
        setPreview(null);
        return;
      }

      if (file.size > MAX_FILE_SIZE_BYTES) {
        // console.error("File is too large. Max allowed size is 20MB.");
        //notify("error", `File is too large. Max allowed size is 20MB.`);
        //setError("File is too large. Please upload a file smaller than 20MB.");
        setPreview(null);
        return;
      }

      if (file) {
        const fileURL = URL.createObjectURL(file); // Creae a preview URL
        setPreview(fileURL);
        // setError("");
      } else {
        setPreview(null); // Reset preview if no file is selected
      }
    };
    
    const [stringTabName, setTabName] = useState(refNumber);

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [isFeeLoading, setIsFeeLoading] = useState(false); 

    const handleReceiptSubmit = (e) => {
        e.preventDefault();

        // const formData = new FormData(e.target);
        // const file = formData.get("file_receipt");
        const file = fileInputRef.current.files[0];
        
        if (!file){
            //console.error("No receipt was selected!");
            notify("warning", `No receipt was selected!`);
            return;
        }

        if (!refNumber || !trackingName) {
            // console.error("Missing refNumber or trackingName!");
            notify("error", `Missing refNumber or trackingName!`);
            return;
        }

        const formData = new FormData();
        formData.append("file_receipt", file);
        formData.append("refNumber", refNumber);
        formData.append("trackingName", trackingName);

        // console.warn("formData content: ");
        // for (const [key, value] of formData.entries()) {
        //     console.log(`${key}:`, value);
        // }
        
        // TODO map displaydata and axios post for each row
        // axios post receipt file
        axios
        .post("https://docuquest-swu.swucite.tech/api_drts/transactionsReceipt.php", formData)
        .then((response) => {
          //console.log("Receipt feedback:", response.data);

          // if receipt image did not exist before, then update it to the new image
          return axios.get(`https://docuquest-swu.swucite.tech/api_drts/transactionsOwner.php/${refNumber}`, {
            params: { trackingName: trackingName },
          });
        })
        .then((response)=>{
          // const uploadedURL = URL.createObjectURL(file);
          // receiptImageRef.current = uploadedURL;
          
          const updatedRequests = response.data;
          const updatedFormattedData = updatedRequests.map((request) => ({
            ...request,
            // refer how data is initially set at const formattedData = requests.map((request) => 
            database_Id: request.id,
            reference: request.reference_number,
            file_receipt: request.file_receipt || "",
            statusPayment: "Paid",
            requested_at: request.created_at,
            purpose: request.purpose_req ? JSON.parse(request.purpose_req).join(", ") : "",
            selected_docs: request.selected_docs ? JSON.parse(request.selected_docs) : [],
            total_price: request.price_total,
            owner_firstname: request.firstname_owner,
            owner_middlename: request.middlename_owner || "",
            owner_lastname: request.lastname_owner,
          }));  

          //console.log("first updated row", updatedFormattedData[0]);

          // update payment status
          axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsPaymentStatus.php/${updatedFormattedData[0].reference}`, {
            owner_lastname: updatedFormattedData[0].owner_lastname,
            statusPayment: "Paid",
          }).then((response) => {
            // console.log("Payment status update response:", response.data);
          }).catch((err) => {
            //console.error("Error updating payment status:", err.response?.data || err.message);
          });
        
          // update receipt image src without reloading component
          setDisplayData(updatedFormattedData);
          notify("success", `Receipt uploaded`);
          
          // Remove preview and close the modal after successful submission
          setPreview(null);
          setShowReceiptModal(false);

          setIsRefreshing(true);
        })
        .catch((error) => {
        notify("error", `Error uploading receipt: ${error}`);
          //console.error("Error uploading receipt:", error);
        });
    }

    const handleDataChange = (e) => {
        const { name, value } = e.target;
        setDisplayData({ ...displayData, [name]: value });
    };

    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    // TODO update to latest status
/*     status: 'Review',
    timestamps: {
        Received: '2024-11-18 10:00 AM',
        Review: '2024-11-18 10:15 AM',
        Processing: '2024-11-18 11:00 AM',
        Document_is_Done: '2024-11-18 11:30 AM',
        Ready_to_Pick_Up_Ship: '2024-11-18 12:00 PM'
    } */

    // TODO update timestamp names to latest status stages
    const [trackingInfo, setTrackingInfo] = useState({
        status: '',
        timestamps: {
            Received: '',
            Review: '',
            Processing: '',
            Document_is_Done: '',
            Ready_to_Pick_Up_Ship: ''
        }
    });

    // TODO fix icons hover. do not show red on hover  
    const stages = [
        { label: 'Request Placed', icon: <FaClipboardCheck /> },
        { label: 'In Review', icon: <FaUserClock /> },
        { label: 'Accepted', icon: <FaPrint /> },
        { label: 'Processing', icon: <FaSpinner /> },
        { label: 'Completed', icon: <FaFileAlt /> },
        { label: 'Out for Delivery/Ready to Pick Up', icon: <FaTruck /> },
        // { label: 'In Transit', icon: <GiPathDistance /> },
        { label: 'Received/Claimed', icon: <FaBoxOpen /> }
    ];

    // TODO function to fill desc with 1 object like { text: 'Your request is being reviewed.', timestamp: formatDateTime(2024-11-18 12:00 PM) },
    const [stages_tracking, setStagesTracking] = useState([
        { label: 'Request Placed', icon: <FaClipboardCheck size={18}/>, desc: [] },
        { label: 'In Review', icon: <FaUserClock size={18}/>, desc: [] },
        { label: 'Processing', icon: <FaSpinner size={18}/>, desc: [] },
        { label: 'Accepted', icon: <FaPrint size={18}/>, desc: [] },
        { label: 'Completed', icon: <FaFileAlt size={18}/>, desc: [] },
        { label: 'Out for Delivery/Ready to Pick Up', icon: <FaTruck size={18}/>, desc: [] },
        // { label: 'In Transit', icon: <GiPathDistance size={18}/>, desc: [] },
        { label: 'Received/Claimed', icon: <FaBoxOpen size={18}/>, desc: [] },
    ]);
    

    const currentStageIndex = stages.findIndex(stage => stage.label === trackingInfo.status);

    const addDescriptionToStage = (label, text, datetime) => {
        setStagesTracking(prevStages =>
            prevStages.map(stage =>
                stage.label === label
                    ? {
                        ...stage,
                        desc: [...stage.desc, { text, datetime }]
                    }
                    : stage
            )
        );
    };
    

    const [displayData, setDisplayData] = useState([]);
    const [editData, setEditData] = useState({
    requestor_name: '',
    requestor_phone: '',
    requestor_email: '',
    owner_firstname: '',
    owner_middlename: '',
    owner_lastname: '',
    owner_phone: '',
    owner_SWU: '',
    owner_course: '',
    owner_course_year: '',
    owner_year_last: '',
    service: '',
    // delivery_region: '',
    // delivery_city: '',
    // delivery_district: '',
    // delivery_street: ''
    });


    const [error, setError] = useState(null);
    const [regionFee, setRegionFee] = useState(null);

    const getRegionFee = (region) => {
        return axios
        .get(`https://docuquest-swu.swucite.tech/api_drts/shippingFee.php`, { params: { region } })
        .then((response) => {
          if (response.data.length > 0) {
            return response.data[0].fee; // Assuming response.data is an array
          } else {
            return "N/A"; // Handle no fee found
          }
        })
        .catch((error) => {
          // console.error(error);
          notify("error", `ERROR fetching region fees: ${error}`);
          return "Error"; // Handle errors
        }); 
    }

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData(prev => ({
          ...prev,
          [name]: value
        }));
    };

    const handleSaveEdits = async (e) => {
        e.preventDefault();
        //alert(`isEditing = ${isEditing}`);
        setIsEditing(false);

        try {
            const response = await axios.patch(
                `https://docuquest-swu.swucite.tech/api_drts/transactions.php/${refNumber}`,
                {
                    owner_lastname: trackingName,
                    // Include all editable fields
                    service: editData.service,
                    requestor_name: editData.requestor_name,
                    requestor_phone: editData.requestor_phone,
                    requestor_email: editData.requestor_email,
                    owner_firstname: editData.owner_firstname,
                    owner_middlename: editData.owner_middlename,
                    owner_phone: editData.owner_phone,
                    owner_course: editData.owner_course,
                    owner_course_year: editData.owner_course_year,
                    owner_year_last: editData.owner_year_last,
                    owner_SWU: editData.owner_SWU,
                    // Reset status to "Request Placed" when saving edits
                    status_transit: "Request Placed"
                }
            );

            if (response.data.status === 1) {
                notify("success", "Changes saved successfully! Request status reset to 'Request Placed'");
                setIsRefreshing(true);
            } else {
                notify("error", "Failed to save changes");
            } 
        } catch (err) {
            notify("error", `Error saving changes: ${error.message}`);
        }
    } 

    // new getting data
    const fetchTrackingDetails = async () => {
        try {
            if (!trackingName) {
                notify("warning", `No tracking name provided!`);
                setIsLoading(false);
                setIsRefreshing(false);
                return;
            }

            const res = await axios.get(`https://docuquest-swu.swucite.tech/api_drts/transactionsOwner.php/${refNumber}`, {
                params: { trackingName: trackingName },
            });

            const requests = res.data;

            const formattedData = requests.map((request) => ({
                database_Id: request.id,
                reference: request.reference_number,
                file_receipt: request.file_receipt || "",
                file_portrait: request.file_portrait || "",
                service: request.service_type,
                region: request.delivery_region || "",
                delivery_city: request.delivery_city || "",
                delivery_district: request.delivery_district || "",
                delivery_street: request.delivery_street || "",
                requestor_address: `${request.delivery_street || ''}, ${request.delivery_district || ''}, ${request.delivery_city || ''}, ${request.delivery_region || ''}`
                    .replace(/, ,/g, ',')
                    .replace(/^, |, $/g, ''),
                selected_docs: request.selected_docs ? JSON.parse(request.selected_docs) : [],
                total_price: request.price_total,
                payment_channel: request.payment_channel,
                doc_type: request.doc_name || "N/A",
                doc_author: request.DOC_author || "N/A",
                doc_catg: request.DOC_category_id || "N/A",
                doc_attached: request.id_doc || "N/A",
                requested_at: request.created_at,
                updated_at: request.updated_at,
                released_at: request.released_at || "",
                requestor_name: request.name_req,
                requestor_phone: request.phone_req,
                requestor_email: request.email_req,
                owner_firstname: request.firstname_owner,
                owner_middlename: request.middlename_owner || "",
                owner_lastname: request.lastname_owner,
                owner_phone: request.phone_owner,
                owner_SWU: request.id_swu || "N/A",
                owner_course: request.course,
                owner_course_year: request.course_year,
                owner_year_last: request.year_last,
                purpose: request.purpose_req ? JSON.parse(request.purpose_req).join(", ") : "",
                description: request.desc_req || "",
                reason_reject: request.reason_reject,
                remarks: request.remarks,
                statusTransit: request.statusTransit,
                statusPayment: request.statusPayment,
                overdue_days: request.overdue_days,
                supporting_docs: (() => {
                    let raw = request.supporting_docs;
                  
                    // null, empty string, and [] string are considered as no docs
                    if (raw == null || raw === "" || raw === "[]") {
                      return [];
                    }
                  
                    let uris = [];
                  
                    if (Array.isArray(raw)) {
                      uris = raw;
                    } else if (typeof raw === "string") {
                      const trimmed = raw.trim();
                  
                      if (trimmed === "[]") {
                        uris = [];
                      }
                      else if (trimmed.startsWith("[")) {
                        try {
                          const parsed = JSON.parse(trimmed);
                          if (Array.isArray(parsed)) uris = parsed;
                        } catch (e) {
                          // console.warn("Could not parse supporting_docs:", e);
                        }
                      }
                      else {
                        // any other non‑empty string
                        uris = [trimmed];
                      }
                    }
                  
                    return uris.map((uri, idx) => ({
                      uri,
                      fileType: "pdf",
                      fileName: `${request.lastname_owner}_suppdoc_${idx + 1}.pdf`
                    }));
                  })(),
            }));
    
            setDisplayData(formattedData);

            if (formattedData.length > 0) {
                const firstItem = formattedData[0];
                setEditData({
                    requestor_name: firstItem.requestor_name,
                    requestor_phone: firstItem.requestor_phone,
                    requestor_email: firstItem.requestor_email,
                    owner_firstname: firstItem.owner_firstname,
                    owner_middlename: firstItem.owner_middlename || '',
                    owner_lastname: firstItem.owner_lastname,
                    owner_phone: firstItem.owner_phone,
                    owner_SWU: firstItem.owner_SWU || '',
                    owner_course: firstItem.owner_course,
                    owner_course_year: firstItem.owner_course_year,
                    owner_year_last: firstItem.owner_year_last,
                    service: firstItem.service
                });

                setTrackingInfo((prev) => ({
                    status: getStatusTransit(formattedData[0].statusTransit),
                    timestamps: {
                        ...prev.timestamps,
                        Document_is_Done: "2024-11-18 12:00 PM", // example timestamp
                    },
                }));
            }
    
            setError(null);
        } catch (err) {
            notify("error", `ERROR fetching transaction ${refNumber}: ${err}`);
            setError(err.message || "Unknown error");
        } finally {
            setIsLoading(false);
            setIsRefreshing(false);
        }
    }

    const docViewerDocuments = useMemo(() => {
        if (displayData.length === 0) return [];
      
        return displayData[0].supporting_docs || [];
    }, [displayData]);

    useEffect(() => {
        // old getting real data
        // if (!trackingName) {
        //     //console.error("No tracking name provided!");
        //     notify("warning", `No tracking name provided!`);
        //     setIsLoading(false);
        //     setIsRefreshing(false);
        //     return;
        // }
    
        // axios
        //     .get(`https://docuquest-swu.swucite.tech/api_drts/transactionsOwner.php/${refNumber}`, {
        //         params: { trackingName: trackingName },
        //     })
        //     .then((res) => {
        //         const requests = res.data;
    
        //         const formattedData = requests.map((request) => ({
        //             database_Id: request.id,
        //             reference: request.reference_number,
        //             file_receipt: request.file_receipt ? request.file_receipt : "",
        //             service: request.service_type,
        //             region: request.delivery_region || "",
        //             delivery_city: request.delivery_city || "",
        //             delivery_district: request.delivery_district || "",
        //             delivery_street: request.delivery_street || "",
        //             requestor_address: `${request.delivery_street || ''}, ${request.delivery_district || ''}, ${request.delivery_city || ''}, ${request.delivery_region || ''}`
        //             .replace(/, ,/g, ',')
        //             .replace(/^, |, $/g, ''),
        //             selected_docs: request.selected_docs ? JSON.parse(request.selected_docs) : [],
        //             total_price: request.price_total,
        //             payment_channel: request.payment_channel,
        //             doc_type: request.doc_name || "N/A",
        //             doc_author: request.DOC_author || "N/A",
        //             doc_catg: request.DOC_category_id || "N/A",
        //             doc_attached: request.id_doc || "N/A",
        //             requested_at: request.created_at,
        //             updated_at: request.updated_at,
        //             released_at: request.released_at || "",
        //             requestor_name: request.name_req,
        //             requestor_phone: request.phone_req,
        //             requestor_email: request.email_req,
        //             owner_firstname: request.firstname_owner,
        //             owner_middlename: request.middlename_owner || "",
        //             owner_lastname: request.lastname_owner,
        //             owner_phone: request.phone_owner,
        //             owner_SWU: request.id_swu || "N/A",
        //             owner_course: request.course,
        //             owner_course_year: request.course_year,
        //             owner_year_last: request.year_last,
        //             purpose: request.purpose_req ? JSON.parse(request.purpose_req).join(", ") : "",
        //             description: request.desc_req || "",
        //             reason_reject: request.reason_reject,
        //             remarks: request.remarks,
        //             statusTransit: request.statusTransit,
        //             statusPayment: request.statusPayment,
        //             overdue_days: request.overdue_days,
        //         }));
    
        //         // console.warn("received data: ", formattedData);
        //         // console.warn("received img receipt: ", formattedData[0].file_receipt);
    
        //         // Use a Promise to ensure the state is updated before proceeding
        //         // FIXME
        //         return new Promise((resolve) => {
        //             setDisplayData(formattedData);
        //             resolve(formattedData);
        //         });
        //     })
        //     .then((formattedData) => {
        //         // Access the updated state here
        //         // console.log("real statusTransit:", formattedData[0]?.statusTransit);
        //         // console.warn(
        //         //     "converted statusTransit:",
        //         //     getStatusTransit(formattedData[0]?.statusTransit)
        //         // );
    
        //         // Update tracking info
        //         if (formattedData.length > 0) {
        //             setTrackingInfo((prev) => ({
        //                 status: getStatusTransit(formattedData[0].statusTransit), // Use the first item's status
        //                 timestamps: {
        //                     ...prev.timestamps,
        //                     Document_is_Done: "2024-11-18 12:00 PM", // Example timestamp update
        //                 },
        //             }));
        //         }
    
        //         setIsLoading(false);
        //     })
        //     .catch((err) => {
        //         //console.error(`ERROR fetching transaction ${refNumber}:`, err);
        //         notify("error", `ERROR fetching transaction ${refNumber}: ${err}`);
        //         setIsLoading(false);
        //     });
        document.title = `Request ${stringTabName}`;
        fetchTrackingDetails();
        fetchCourses();
    }, []);
    
    useEffect(() => {
        fetchTrackingDetails();
        // alert(`isRefreshing = ${isRefreshing}`)
    }, [isRefreshing]);

    useEffect(() => {
        if (displayData[0]?.region) {
          setIsFeeLoading(true);
          getRegionFee(displayData[0].region).then((fee) => {
            setRegionFee(fee);
            setIsFeeLoading(false);
          });
        }
    }, [displayData]);
    
    const formatDate = (timestamp) => {
        const date = new Date(timestamp); 
        return date.toLocaleDateString('en-US', {
            month: 'short', 
            day: 'numeric', 
            year: 'numeric' 
        });
    };

    const formatDateTime = (timestamp) => {
        const date = new Date(timestamp); 
        return date.toLocaleDateString('en-US', {
            month: 'short', 
            day: 'numeric', 
            year: 'numeric' 
        }) + ' ' + date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false, // Use false for 24-hour format; true for 12-hour format
        });
    };

    const updateTrackingInfo = (newStatus, newTimestamp) => {
        setTrackingInfo(prev => ({
            ...prev,
            status: newStatus, // Update the status
            timestamps: {
                ...prev.timestamps, // Retain existing timestamps
                [newStatus]: newTimestamp // Dynamically add or update timestamp
            }
        }));
    };

    // refer to statusTransit from database for case names
    const getStatusTransit = (statusTransitRequest) => {
        //notify("warning", `statusTransitRequest = ${statusTransitRequest}`);
        switch (statusTransitRequest) {
            case "Request Placed":
                return "Request Placed"; 
            case "In Review":
                return "In Review";
            case "Payment Sent":
                return "In Review"; // trail stays on in review since payment receipt is needed to accept     
            case "Accepted":
                return "Accepted";
            case "Rejected":
                return "Rejected";       
            case "Processing":
                return "Processing";                   
            case "Completed":
                return "Completed";
            case "For Releasing":
                return "Out for Delivery/Ready to Pick Up";       
            case "Ready to Pick Up":
                return "Out for Delivery/Ready to Pick Up";
            case "Out for Delivery":
                return "Out for Delivery/Ready to Pick Up";
            // case "In Transit":
            //     return "In Transit"; // maps to In Transit
            case "Delivered":
                return "Received/Claimed";
            case "Received":
                return "Received/Claimed";
            case "Claimed":
                return "Received/Claimed";
            default:
                // notify("error", `INVALID transit status`);
                notify("warning", `Redirected transit status to Request Placed`);
                // console.error("INVALID transit status");
                // console.warn("redirected transit status to Request Placed");
                return "Request Placed"; // Default stage if no matches
        }
    };

    const getTimestamps = (timestampsRequest) => {

    }

    // useEffect(() => {
    //     if (displayData.status_transit) {
    //         const updatedStatus = getStatusTransit(displayData.status_transit);
    //         console.warn("Received status: ", displayData.status_transit);
    //         console.warn("Progress bar status: ", updatedStatus);
            
    //         setTrackingInfo((prev) => ({
    //             ...prev,
    //             status: updatedStatus,
    //         }));
    //     }
    // }, [displayData.status_transit]);
    

    let btnBack = <Button variant="outline-dark" onClick={() => handleNavigation(-1)}>Back</Button>;
    
    // dynamic back button
    // if (!sessionStorage.getItem("role_user")) {
    //     btnBack = (
    //         <Button variant="outline-dark" onClick={() => handleNavigation('/manage/requests')}>Back to My Requests</Button>
    //     );
    // } else {
    //     btnBack = (
    //         <Button variant="outline-dark" onClick={() => handleNavigation('/transactions')}>Back to All Transactions</Button>
    //     );
    // }

    // FIXME addDescriptionToStage not working
    useEffect(() => {
        addDescriptionToStage("In Review", "Your request is being reviewed.", formatDateTime(new Date().toISOString()));
    }, []);

    return (
        <div id='content-singletrack'>
            <article className='container-actions'>
                {btnBack}
                <Button id='refresh' variant="secondary" onClick={() => setIsRefreshing(prev => !prev)}>
                Refresh
                </Button>
            </article>

            {displayData.length > 0 && displayData[0]?.requested_at && trackingInfo.status && (
                <div className="tracking-rail">
                    {stages.map((stage, index) => {
                        const currentStatus = getStatusTransit(displayData[0]?.statusTransit || "");

                        // Check if the current stage is "Rejected" or "Received/Claimed"
                        const isRejected = displayData[0]?.statusTransit === "Rejected" && stage.label === "Accepted";
                        const isReceivedOrClaimed = currentStatus === "Received/Claimed" && stage.label === "Received/Claimed";

                        const currentStageIndex = stages.findIndex(
                            (s) => s.label === currentStatus
                        );

                        const isCurrentStage = index === currentStageIndex;
                        const isNextStage = index === currentStageIndex + 1;

                        // Determine the appropriate progress bar class
                        const progressBarClass = isCurrentStage
                            ? isRejected || isReceivedOrClaimed
                                ? "stage-progress-bar completed"
                                : "stage-progress-bar current"
                            : index <= currentStageIndex
                            ? "stage-progress-bar completed"
                            : "stage-progress-bar";

                        // Determine the appropriate status rail item class
                        const railItemClass = `${index <= currentStageIndex ? "completed" : ""} ${
                            isCurrentStage && (isRejected || isReceivedOrClaimed) ? "completed" : isCurrentStage ? "current" : ""
                        }`;

                        // Determine the appropriate status label class
                        const labelClass = isCurrentStage && (isRejected || isReceivedOrClaimed)
                            ? "status-label completed"
                            : isNextStage
                            ? "status-label next"
                            : isCurrentStage
                            ? "status-label current"
                            : "status-label";

                        return (
                            <div
                                key={stage.label}
                                {...(isCurrentStage ? { title: `Your request status: ${stage.label}` } : {})}
                                className={`status-rail-item ${railItemClass}`}
                            >
                                <div className="status-icon">
                                    {isRejected ? <FaRegTimesCircle /> : stage.icon}
                                </div>
                                <div
                                    className={labelClass}
                                    data-label={isRejected ? "Rejected" : stage.label}
                                >
                                    {isRejected ? "Rejected" : stage.label}
                                </div>
                                {/* Apply the correct class to the progress bar */}
                                <div className={progressBarClass} />
                            </div>
                        );
                    })}
                </div>
            )}

            {!isLoading && 
            displayData.length > 0 && 
            displayData[0].overdue_days > 0 &&
            displayData[0]?.statusTransit !== "Delivered" &&
            displayData[0]?.statusTransit !== "Claimed" &&
            (

            <>
                <strong>Delayed</strong>&nbsp;
                {`We apologize your request was delayed. If your requested documents have not been released/delivered by ${formatDate(displayData[0].released_at)}, you may contact the registrar's department at `}
                <strong>registrar.swu@phinmaed.com</strong>  
            </>
            )}

            <article className='container-info-tracking'>
                <section className='data'>
                <h5 className='header'>{displayData.length > 0 ? displayData[0].reference : "No reference available"}</h5>
                <div className='body' id='data-refrelease'>
                    
                    {displayData[0]?.statusTransit === "Rejected" && (
                        <div>
                            <table>
                              <thead>
                                <tr>
                                  <h5>{displayData[0]?.statusTransit}</h5>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th scope="row">Reason</th>
                                  <td>{displayData[0]?.reason_reject}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Remarks</th>
                                  <td>{displayData[0]?.remarks}</td>
                                </tr>
                              </tbody>
                            </table>
                        </div>
                    )
                    }
                
                    {isLoading ? (
                    <p>Loading...</p>
                    ) :(
                      <>
                        {`Requested\u00A0at: `}<h5>{displayData.length > 0 ? formatDate(displayData[0].requested_at) : "No requested at date"}</h5>

                        {/* {`Released\u00A0at: `}<h5>{displayData[0].released_at ? formatDate(displayData[0].released_at) : "No release date"}</h5> */}
                        
                        {displayData.length > 0 && displayData[0]?.released_at?.trim() ? (
                            <>
                              {`Released\u00A0at: `} <h5>{formatDate(displayData[0].released_at)}</h5>
                            </>
                            ) : null
                        }

                        {/* {displayData.requested_at && (
                        <>
                            Requested at: <h5>{formatDate(displayData[0].requested_at)}</h5>
                        </>
                        )}     */}

                        {/* {displayData.released_at && (
                        <>
                            Released at: <h5>{formatDate(displayData[0].released_at)}</h5>
                        </>
                        )} */}
                      </>
                    )
                    }
                
                  <div className='split-body'>
                    <article className='form-readonly'>
                    
                    <div className='label-wrapper-readonly'>
                      <label for='read_service'>Service:</label>
                      <input readOnly name='read_service' type='text' value={displayData.length > 0 ? displayData[0].service : "No service type available"}/>
                    </div>

                    <div className='label-wrapper-readonly'>
                      <label for='read_purpose'>Purpose:</label>
                      {/* <input readOnly name='read_purpose' type='text' value={displayData.length > 0 ? displayData[0].purpose : "No purpose available"}/> */}
                      <textarea 
                          readOnly 
                          name='read_purpose' 
                          value={displayData.length > 0 ? displayData[0].purpose : "No purpose available"}
                        />
                    </div>

                    {displayData.length > 0 && displayData[0].description ? (
                      <div className='label-wrapper-readonly'>
                        <label for='read_desc'>Description:</label>
                        <textarea 
                          readOnly 
                          name='read_desc' 
                          value={displayData.length > 0 ? displayData[0].description : ""}
                        />
                      </div>
                    ) : null
                    }

                    </article>

                    {Array.isArray(displayData[0]?.selected_docs) && displayData[0].selected_docs.length > 0 ? (
                    <table>
                        <thead>
                        <tr>
                            <th>Document</th>
                            <th>Copies</th>
                            <th>Price</th>
                        </tr>
                        </thead>
                        <tbody>
                        {displayData[0].selected_docs.map((doc, idx) => (
                            <tr key={idx}>
                            <td>{doc.document}</td>
                            <td>{doc.quantity}</td>
                            <td>{doc.price ? `₱${doc.price.toFixed(2)}` : "₱0.00"}</td>
                            </tr>
                        ))}
                        
                        {displayData[0]?.region && (
                            <tr>
                                <td style={{ textAlign: "left" }}>Delivery&nbsp;region:&nbsp;</td>
                                <td>{displayData[0].region}</td>
                                <td>
                                {isFeeLoading ? "Loading..." : regionFee ? `₱${regionFee}` : "Error"}
                                </td>
                            </tr>
                        )}

                        <tr>
                            <td colSpan="2" style={{ fontWeight: "bold", textAlign: "right" }}>Total:</td>
                            <td style={{ fontWeight: "bold" }}>
                                {displayData[0].total_price ? `₱${displayData[0].total_price.toFixed(2)}` : "₱0.00"}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    ) : (
                    <span>No documents selected</span>
                    )}
                  </div>

   


                
                </div>
                </section>

                <section className='data'>
                <h5 className='header'>Requestor & Owner</h5>

                {displayData[0]?.file_portrait ? (
                        <div>
                            <img
                                // ref={receiptImageRef}
                                // receiptImageRef.current ||
                                src={displayData[0].file_portrait || ""}
                                title={`Portrait of ${displayData[0].owner_lastname}, ${displayData[0].owner_firstname} ${displayData[0].owner_middlename}`}
                                alt="Owner portrait"
                                className='view-portrait'
                            />
                            <h5>Owner Portait</h5>
                        </div>
                    ) : (
                        <div>
                        <p>No portrait attached</p>
                        </div>
                    )
                }

                {isLoading ? (
                <p>Loading supporting document…</p>
                ) : docViewerDocuments.length > 0 ? (
                <div style={{ height: '75vh', overflowY: 'auto' }}>
                    <DocViewer
                    documents={docViewerDocuments}
                    pluginRenderers={DocViewerRenderers}
                    style={{ width: '100%', height: '100%' }}
                    />
                </div>
                ) : (
                <p>No supporting document provided.</p>
                )}  

                {displayData[0]?.statusTransit === "Rejected" && (
                    !isEditing ? (
                        <div>
                            <Button variant="outline-primary" size="sm" onClick={() => setIsEditing(true)}>
                                Edit Request
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <Button variant="outline-success" size="sm" onClick={handleSaveEdits} className="me-2">
                                Save Changes
                            </Button>
                            <Button variant="outline-danger" size="sm" onClick={() => setIsEditing(false)}>
                                Cancel
                            </Button>
                        </div>
                    )
                )}
                <div className='body' id='data-requesteorowner'>
                
                  <div className='split-body'>
                  <article className='form-readonly'>
                
                <h5>Requestor</h5>
                  <div className='label-wrapper-readonly'>
                    <label for='read_requestor_name'>Name:</label>
                    {isEditing ? (
                        <input 
                            name='requestor_name' 
                            type='text' 
                            value={editData.requestor_name}
                            onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')} 
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_requestor_name' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].requestor_name : "No requestor name available"}
                        />
                    )}
                  </div>
                
                  <div className='label-wrapper-readonly'>
                    <label for='read_requestor_phone'>Phone:</label>
                    {isEditing ? (
                        <input 
                            name='requestor_phone' 
                            type='text' 
                            value={editData.requestor_phone}
                            onInput={(e) => e.target.value = e.target.value.replace(/[^0-9\-]/g, '')} 
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_requestor_phone' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].requestor_phone : "No requestor phone available"}
                        />
                    )}
                  </div>
 
                  <div className='label-wrapper-readonly'>
                    <label for='read_requestor_email'>Email:</label>
                    {isEditing ? (
                        <input 
                            name='requestor_email' 
                            type='email' 
                            value={editData.requestor_email}
                            onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z0-9.@]/g, '')}  
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_requestor_email' 
                            type='email' 
                            value={displayData.length > 0 ? displayData[0].requestor_email : "No requestor email available"}
                        />
                    )}
                  </div>

                  <h5>Claim Information</h5>
                    {isClaimLoading ? (
                    <p>Loading claim information...</p>
                    ) : (
                    <>
                        <div className='label-wrapper-readonly'>
                        <label for='read_receiver_name'>Received by:</label>
                        <input 
                            readOnly 
                            name='read_receiver_name' 
                            type='text' 
                            value={claimData.receiver_name || "Not yet claimed"}
                        />
                        </div>
                        
                        <div className='label-wrapper-readonly'>
                        <label for='read_receive_date'>Receive date:</label>
                        <input 
                            readOnly 
                            name='read_receive_date' 
                            type='text' 
                            value={claimData.receive_date ? formatDate(claimData.receive_date) : "Not yet claimed"}
                        />
                        </div>
                        
                        <div className='label-wrapper-readonly'>
                        <label for='read_claimed_by'>Processed by:</label>
                        <input 
                            readOnly 
                            name='read_claimed_by' 
                            type='text' 
                            value={claimData.claimed_by || "Not yet claimed"}
                        />
                        </div>
                    </>
                    )}

                  {displayData.length > 0 && displayData[0].service === "Delivery" ? (
                    <div className='label-wrapper-readonly'>
                        <label htmlFor='read_address'>Address:</label>
                        <textarea readOnly name='read_address'>
                        {displayData[0].requestor_address || 'no requestor address'}
                        </textarea>
                    </div>
                    ) : null}

                  </article>
                  
                  <article className='form-readonly'>
                  <h5>Owner</h5>
                  <div className='label-wrapper-readonly'>
                    <label for='read_owner_name'>Name:</label> 
                    {isEditing ? (
                        <input 
                            name='owner_firstname' 
                            type='text' 
                            value={editData.owner_firstname}
                            onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}  
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_owner_firstname' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].owner_firstname : ""}
                        />
                    )}
                  </div>

                  <div className='label-wrapper-readonly'>
                    <label htmlFor='owner_middlename'>Middle Name:</label>
                    {isEditing ? (
                        <input 
                            name='owner_middlename' 
                            type='text' 
                            value={editData.owner_middlename}
                            onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}  
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_owner_middlename' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].owner_middlename || "" : ""}
                        />
                    )}
                  </div>  

                  <div className='label-wrapper-readonly'>
                    <label htmlFor='owner_lastname'>Last Name:</label>
                    {isEditing ? (
                        <input 
                            name='owner_lastname' 
                            type='text' 
                            value={editData.owner_lastname}
                            onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}  
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_owner_lastname' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].owner_lastname : ""}
                        />
                    )}
                  </div>

                  <div className='label-wrapper-readonly'>
                    <label for='read_owner_phone'>Phone:</label>
                    {isEditing ? (
                        <input 
                            name='owner_phone' 
                            type='text' 
                            value={editData.owner_phone}
                            onInput={(e) => e.target.value = e.target.value.replace(/[^0-9\-]/g, '')} 
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_owner_phone' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].owner_phone : "No owner phone available"}
                        />
                    )}
                  </div>
                  
                  {displayData.length > 0 && displayData[0].owner_SWU && (
                    <div className='label-wrapper-readonly'>
                        <label htmlFor='owner_SWU'>Student ID:</label>
                        {isEditing ? (
                            <input 
                                name='owner_SWU' 
                                type='text' 
                                value={editData.owner_SWU} 
                                placeholder='XX-XXXX-XXXXX'
                                maxLength={13}
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9\-]/g, '')} 
                                onChange={handleEditChange} 
                            />
                        ) : (
                            <input 
                                readOnly 
                                name='read_owner_SWU' 
                                type='text' 
                                value={displayData.length > 0 ? displayData[0].owner_SWU : ""}
                            />
                        )}
                    </div>
                    )}

                  <div className='label-wrapper-readonly'>
                    <label for='read_owner_course'>Course:</label>
                    {isEditing ? (
                        <Form.Select 
                            name='owner_course' 
                            value={editData.owner_course} 
                            onChange={handleEditChange}
                        >
                            <option value="">Select Course</option>
                            {courses.map((course) => (
                                <option key={course.id} value={course.course_name}>
                                    {course.course_name}
                                </option>
                            ))}
                        </Form.Select>
                    ) : (
                        <input 
                            readOnly 
                            name='read_owner_course' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].owner_course : "No owner course available"}
                        />
                    )}
                  </div>
                
                  <div className='label-wrapper-readonly'>
                    <label for='read_owner_course_year'>Year&nbsp;Enrolled:</label>
                    {isEditing ? (
                        <input 
                            name='owner_course_year' 
                            type='text' 
                            value={editData.owner_course_year}
                            maxLength={4}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            }} 
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_owner_course_year' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].owner_course_year : "No owner course year available"}
                        />
                    )}
                  </div>

                  <div className='label-wrapper-readonly'>
                    <label for='read_owner_course_year'>Last&nbsp;year in&nbsp;SWU:</label>
                    {isEditing ? (
                        <input 
                            name='owner_year_last' 
                            type='text' 
                            value={editData.owner_year_last}
                            maxLength={4}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            }} 
                            onChange={handleEditChange} 
                        />
                    ) : (
                        <input 
                            readOnly 
                            name='read_owner_year_last' 
                            type='text' 
                            value={displayData.length > 0 ? displayData[0].owner_year_last : "No owner year last available"}
                        />
                    )}
                  </div>

                  </article>  
                  </div>

                </div>
                </section>
                
                <section className='data'>
                <h5 className='header'>Payment Status</h5>
                {/* Hide overdue if transaction is not overdue */}
                {displayData.length > 0 && displayData[0]?.overdue_days > 0 ?
                  (
                    <div>
                      <h5>{`Days Overdue:`}</h5>
                      <span>{displayData[0].overdue_days}</span>
                      <br/>
                    </div>
                  ) : "  "
                }

                <>
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    <>
                        {displayData.length > 0 && displayData[0]?.statusPayment
                            ? displayData[0].statusPayment
                            : "No payment status available"}

                        <br/>

                        {displayData.length > 0 && displayData[0]?.payment_channel
                            ? displayData[0].payment_channel
                            : "No payment channel available"}

                        {/* Move the variable definition outside JSX */}
                        {(() => {
                            const isDisabled = !["Rejected", "Accepted", "Processing"].includes(displayData[0].statusTransit);
                            
                            return displayData[0].file_receipt || receiptImageRef.current ? (
                                <div>
                                    <img
                                        // ref={receiptImageRef}
                                        // receiptImageRef.current ||
                                        src={displayData[0].file_receipt || ""}
                                        title={`Uploaded receipt of ${refNumber}`}
                                        alt="Uploaded Receipt"
                                        style={{ maxWidth: "300px", height: "auto", border: "1px solid #ddd" }}
                                    />
                                    <h5>Uploaded Receipt</h5>
                                </div>
                            ) : (
                                <div>
                                    <Button variant='primary' disabled={isDisabled} onClick={() => setShowReceiptModal(true)}>Upload Receipt</Button>
                                </div>
                            );
                        })()}
                    </>
                )}


                    <Modal show={showReceiptModal} onHide={() => setShowReceiptModal(false)} centered>
                        <Modal.Header >
                            <Modal.Title>Upload Receipt</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form onSubmit={handleReceiptSubmit}>
                            <Form.Group controlId="formFile">
                            <Form.Label>Upload Receipt</Form.Label>
                            <Form.Control
                                ref={fileInputRef}
                                required
                                type="file"
                                name="file_receipt"
                                accept="image/png, image/jpeg, application/pdf"
                                onChange={handleFileChange}
                            />
                            </Form.Group>

                            {/* Image Preview */}
                            {preview && (
                            <div className="mt-3">
                                <p>Image Preview:</p>
                                <img
                                src={preview}
                                alt="Selected Receipt"
                                style={{ maxWidth: "100%", height: "auto", border: "1px solid #ddd" }}
                                />
                            </div>
                            )}

                            {/* <button type='submit' classname=''>
                            Submit
                            </button> */}
                            <Button variant="primary" type="submit" className="mt-3">
                                Submit
                            </Button>
                          </Form>
                        </Modal.Body>
                    </Modal>
                </>

                  {/* {
                    displayData.length > 0
                    ? displayData[0].statusPayment
                    : "No payment status available"    
                  }

                  {displayData[0].statusPayment === 'Not Paid' ? (
                    <div>
                        <button onClick={''}>Pay now</button>
                    </div>
                  ) : null
                  } */}
                </section>
            </article>
            {/* .filter((_, index) => index <= currentStageIndex)  */}
            {/* <span className="stage-icon">{stageIcon}</span> */}
            {/* 
            <ul className="tracking-status-list">
            {stages_tracking
                .map((stage, index) => {
                const isRejected =
                    stage.label === 'Accepted' && displayData.status_transit === 'Rejected';

                const stageLabel = isRejected ? 'Rejected' : stage.label;
                const stageIcon = isRejected ? <FaRegTimesCircle size={18} /> : stage.icon;

                const stageTimestamp =
                    stage.label === 'Received'
                    ? displayData.requested_at
                    : trackingInfo.timestamps[stage.label];

                if (index > currentStageIndex + 1) {
                    return null;
                }
                
                return (
                    <li
                    key={stage.label}
                    className={`status-list-item ${index < currentStageIndex ? 'completed' : ''} ${index === currentStageIndex ? 'current' : ''}`}
                    >
                    {index <= currentStageIndex ? (
                        <FaCheckCircle className="check-icon" />
                    ) : (
                        <span className="circle-icon" />
                    )}

                    {stageLabel}

                    {stage.desc.length > 0 && (
                        <p className="stage-description">

                        </p>
                    )}

                    {index < currentStageIndex && stageTimestamp && (
                        <span className="timestamp">
                        {stageTimestamp}
                        </span>
                    )}
                    </li>
                );
                })}
            </ul>
            */}
            <ToastContainer newestOnTop/>
        </div>
    )
}